<div class="g-0">
    <div class="col">
        <div class="box-wrapper">
            <div class="box-content-header">
                <div class="row p-1">
                    <div class="col">
                        <div class="px-2 d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fa-solid fa-circle-info"></i>
                                <span class="ms-2">Informații Inchidere Proiect</span>
                            </div>
                            <button
                                *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                class="btn btn-small btn-primary edit-btn" (click)="toggleEditField()">
                                <i class="fa fa-pencil" *ngIf="!showEditField"></i>
                                <i class="fa fa-close" *ngIf="showEditField"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-content-body">
                <!-- Show Info Field -->
                <ng-container *ngIf="!showEditField">
                    <div class="row py-1 mx-1 bg">
                        <div class="col-6">
                            <div class="fw-bold">Garanție pană la</div>
                        </div>
                        <div class="col-6">
                            <div class="fw-bold">Mod închidere</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1">
                        <div class="col-6">
                            <div class="">{{ proiect.garantie }}</div>
                        </div>
                        <div class="col-6">
                            <div *ngIf="proiect.finished_type === 1" class="">
                                Conform
                                <i class="fa fa-check green-text"></i>
                            </div>
                            <div *ngIf="proiect.finished_type === 2" class="">
                                Neconform
                                <i class="fa fa-close red-text"></i>
                            </div>
                        </div>
                    </div>

                    <div class="row py-1 mx-1 bg">
                        <div class="col">
                            <div class="fw-bold">Observații</div>
                        </div>
                    </div>
                    <div class="row py-1 mx-1">
                        <div class="col">
                            <div class="" [innerHTML]="proiect.validated_obs || 'n/a'"></div>
                        </div>
                    </div>


                    <div class="row py-1 mx-1 bg">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="fw-bold">
                                    Documente/Fotografii
                                </div>
                                <button
                                    *ngIf="!showUploadField && permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.update')"
                                    type="button" class="btn btn-small btn-primary" (click)="toggleUploadField()">
                                    Încarcă
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- Show Files -->
                    <ng-container *ngIf="!showUploadField">
                        <div class="row py-1 mx-1">
                            <div class="col">
                                <div *ngFor="let document of proiect.documente_garantie | keyvalue">
                                    <div *ngFor="let file of document.value.files">
                                        <div class="row align-items-center mb-1">
                                            <div class="col-auto">
                                                <img src="assets/icons/doc-icon.svg" alt="Document">
                                            </div>
                                            <div class="col">
                                                <div class="document-title">{{ file.type_name}}</div>
                                                <div>Denumire document: {{ file.name_original }}</div>
                                            </div>
                                            <div class="col-auto ms-auto">
                                                <button type="button" class="btn btn-light document-open-btn"
                                                    (click)="downloadDocument(file.id_document)">
                                                    <img src="/assets/icons/view.svg" alt="VIZUALIZAȚI" />
                                                    <span class="text">VIZUALIZAȚI</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <!-- Upload Files -->
                    <ng-container *ngIf="showUploadField">
                        <form class="p-1" [formGroup]="formFiles" (submit)="uploadFiles()">
                            <div class="document-upload mb-3">
                                <div class="document-upload-header">
                                    <p class="upload-text">Fotografii/Documente</p>
                                    <button class="upload-btn" (click)="fileInput.click()" type="button">
                                        <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                                        ÎNCARCĂ
                                    </button>
                                </div>
                                <div class="document-upload-files" *ngIf="
                                    formFiles.value.files.length > 0 &&
                                    !uploading
                                ">
                                    <div class="document-upload-file" *ngFor="
                                        let uploadedFile of formFiles.value.files;
                                        let i = index
                                    ">
                                        <span class="document-upload-file-name">
                                            {{
                                            uploadedFile.original_name.length > 30
                                            ? (uploadedFile.original_name | slice : 0 : 30) +
                                            ".."
                                            : uploadedFile.original_name
                                            }}
                                        </span>
                                        <div>
                                            <button class="document-upload-file-delete" type="button"
                                                matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                                <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                    *ngIf="uploading"></mat-spinner>

                                <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                                    id="upload-file-input-0" #fileInput name="fileInput"
                                    (change)="addFile($event, 'file')" multiple style="display: none" />
                            </div>

                            <div class="row mt-2">
                                <div class="col d-flex justify-content-between">
                                    <button type="button" class="btn btn-small btn-warning"
                                        (click)="closeUploadField()">
                                        Închide
                                    </button>
                                    <button type="submit" class="btn btn-small btn-primary"
                                        [disabled]="formFiles.invalid">
                                        Actualizează
                                    </button>
                                </div>
                            </div>
                        </form>
                    </ng-container>
                </ng-container>

                <!-- Show Edit Field -->
                <ng-container *ngIf="showEditField">
                    <form class="p-1" [formGroup]="form" (submit)="submitForm()">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Garanție</mat-label>
                                    <input matInput [matDatepicker]="pickerGarantie" formControlName="garantie_date"
                                        readonly (focus)="pickerGarantie.open()" />
                                    <mat-datepicker-toggle matIconSuffix [for]="pickerGarantie"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerGarantie></mat-datepicker>
                                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                                    <mat-error
                                        *ngIf="!form.controls['garantie_date'].valid && form.controls['garantie_date'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-md-6">
                                <mat-form-field class="w-100" appearance="fill">
                                    <mat-label>Închidere Proiect Conform?</mat-label>
                                    <mat-select formControlName="finished_type">
                                        <mat-option *ngFor="let row of finalizare_type" [value]="row.value">
                                            {{ row.key }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error
                                        *ngIf="!form.controls['finished_type'].valid && form.controls['finished_type'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="fw-bold p-1">Observații</div>
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="validated_obs"
                                    [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="!form.controls['validated_obs'].valid && form.controls['validated_obs'].touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col d-flex justify-content-between">
                                <button type="button" class="btn btn-small btn-warning" (click)="closeEditField()">
                                    Închide
                                </button>
                                <button type="submit" class="btn btn-small btn-primary" [disabled]="form.invalid">
                                    Salvează
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>